import(/* webpackMode: "eager", webpackExports: ["NotFoundContent"] */ "/builds/empiriecom/core/frontend/turborepo/apps/shopping/src/app/[lang]/(shop)/NotFoundContent.client.tsx");
